<div class="flex stick w-auto min-h-2px align-items-center">
  <div class="thread_title flex-shrink" [class.font-bold]="!thread?.childCategoryName">
    {{ thread?.parentCategoryName }}
  </div>
  @if (thread?.childCategoryName) {
    <div class="flex align-items-center flex-shrink">
      <i class="fa fa-sm fa-arrow-right px-2"></i>
      <span class="thread_subtitle font-bold">{{ thread?.childCategoryName }}</span>
    </div>
  }
  @if (thread?.dateArchived) {
    <div class="thread_title">Closed: {{ formatTime(thread?.dateArchived!) }}</div>
  }
  @if (!thread?.dateArchived && thread?.id !== 'new') {
    <div class="flex-none ml-auto hover-pointer">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  }
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="handleMarkThreadAsUnread()" [disabled]="canMarkAsUnread()">Mark as unread</button>
</mat-menu>
